import { useState } from "react";
import ImageX from "components/utility/images/ImageX";
import MaterialBoxGatedDownloadModalForm from "./MaterialBoxGatedDownloadModalForm";
import MaterialBoxDownloadThankYou from "./MaterialBoxGatedDownloadThankYou";
import { sanitizeHtml } from "utils/sanitizeHtml";
import { DDXModal } from "components/ddx-modal/DDXModal";
import { MaterialBoxGatedProps } from "../MaterialBoxGatedProps";

const MaterialBoxGatedDownloadModal = ({
	data,
	isOpen,
	closeModal
}: React.PropsWithChildren<MaterialBoxGatedProps>) => {
	const [successFlag, setSuccessFlag] = useState<boolean>(true);
	const [submitFlag, setSubmitFlag] = useState<boolean>(false);

	const closeFormModal = () => {
		closeModal();
		setSubmitFlag(false);
		setSuccessFlag(true);
	};

	const displayThankyouMessage = () => {
		setSubmitFlag(true);
		setSuccessFlag(true);
	};

	const displayErrorMessage = () => {
		setSuccessFlag(false);
	};

	const { imageUrl, imageAlt } = data;
	const { modalTitle, modalDescription } = data.modal;
	const { successMessageTitle } = data.modal.successMessage;
	const { errorTitle, errorMessage } = data.modal.error;

	return (
		<DDXModal showModal={isOpen} handleCloseModal={closeFormModal} className="material-box-modal">
			<div className="material-box-modal-content">
				<div className="material-box-modal-header">
					<div className="material-box-modal-header-title">
						{submitFlag === false && successFlag === true ? (
							<h1 dangerouslySetInnerHTML={{ __html: sanitizeHtml(modalTitle) }}></h1>
						) : submitFlag === true && successFlag === true ? (
							<h1 dangerouslySetInnerHTML={{ __html: sanitizeHtml(successMessageTitle) }}></h1>
						) : successFlag === false && successFlag === false ? (
							<h1>{errorTitle}</h1>
						) : null}
					</div>
					<button
						className="material-box-modal-header-close"
						onClick={closeFormModal}
						aria-label="close modal"
					>
						<ImageX />
					</button>
				</div>
				{successFlag === true ? (
					<div className="material-box-modal-desc">
						{submitFlag === false ? (
							<div
								className="material-box-modal-description"
								dangerouslySetInnerHTML={{ __html: sanitizeHtml(modalDescription) }}
							></div>
						) : null}

						<div className="material-box-modal-grid ">
							{imageUrl ? (
								<div className="material-box-modal-thumbnail ">
									<div className="content-page-module-pdf-thumbnail-img">
										<img src={imageUrl} alt={imageAlt} data-qa="material-box-pdf-thumbnail" />
									</div>
								</div>
							) : null}
							<div className={"material-box-modal-desc-form"}>
								{submitFlag === false ? (
									<MaterialBoxGatedDownloadModalForm
										data={data}
										submitFlag={submitFlag}
										displayThankyouMessage={displayThankyouMessage}
										displayErrorMessage={displayErrorMessage}
									/>
								) : (
									<MaterialBoxDownloadThankYou data={data} />
								)}
							</div>
						</div>
					</div>
				) : (
					<div
						className="material-box-modal-desc-error"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(errorMessage) }}
					></div>
				)}
			</div>
		</DDXModal>
	);
};

export default MaterialBoxGatedDownloadModal;
